import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 创建公会获取主要页面状态
export const getHomepage = createAsyncThunk(
  'Saada/live/hiya_socialize/bd_invite_union_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/hiya_socialize/bd_invite_union_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 提交公会信息
export const subUnion = createAsyncThunk(
  'Saada/live/hiya_socialize/check_submit_bd_create_union',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/check_submit_bd_create_union',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const AnchorListOptions = [
  {
    value: '5-10',
    label: '5-10',
  },
  {
    value: '11-20',
    label: '11-20',
  },
  {
    value: '21-30',
    label: '21-30',
  },
]
export enum SubTypeEnum {
  同意 = 1,
  拒绝 = 2,
  检查 = 3,
  提交 = 4,
}

// 操作状态
export enum AcceptStatusEnum {
  未操作 = 0, // page1
  已接受 = 1, // page2
  已拒绝 = 2, // page1 grey
  信息驳回 = 3, // page2 按钮grey  上面展示运营原因文案
  运营拒绝 = 4, // page2 按钮grey 无法更改 上面展示运营拒绝文案
  成功创建 = 5, // page2 按钮grey 无法更改
  已过期 = 6, // page1 grey
  待审核 = 7, // page2 按钮grey 无法更改 上面展示审核中
}

export interface InitialStateType {
  err_msg?: string
  reason?: string
  accept_status?: AcceptStatusEnum
  bd_mid?: number
  union_info?: {
    name: string // 名字
    host_num: string // 主播人数
    contact_type: string // 联系方式
    contact_num: string // 联系方式number
    app_history: string // app 历史
    app_screenshot: string // app 截图
    union_country: number // 公会国家
    country: number // 区号
  }
}

const initialState: InitialStateType = {
  accept_status: AcceptStatusEnum.已过期,
}
export const SaadaUnionWelcomeSlice = createSlice({
  name: 'SaadaUnionWelcome',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload.data)
    })
  },
})

export default SaadaUnionWelcomeSlice.reducer
